<template>
    <div class="collapse-body pb-0">
        <div class="row">
            <div class="col-md-6">
                <csp-create-claim-type-form
                    :record-form="recordForm"/>

                <csp-create-damage-form :record-form="recordForm"/>
            </div>

            <div class="col-md-4">
                <csp-create-damage-map-image :damage-form="recordForm.getSubform('damage')"/>
            </div>

            <div class="col-md-2">
                <csp-record-create-image-file-upload
                    accepted-mime-types="image/jpeg, image/png, application/pdf"
                    transform-mime-types="image/jpeg, image/png"
                    :upload-file-category-id="uploadFileCategory"
                    upload-label="Unfall Foto"
                    :upload-session-id="uploadSessionId"/>
            </div>
        </div>
    </div>
</template>

<script>
    import RecordCreateForm from '@csp-app/lib/damage/record/create/RecordCreateForm';
    import FileCategoryEnum from '@js/enums/file/FileCategoryEnum';
    import CreateDamageForm from '@csp-app/views/recordByCustomer/form/CreateDamageForm';
    import CreateDamageMapImage from '@csp-app/components/record/CreateDamageMapImage.vue';
    import CreateClaimTypeForm from '@csp-app/views/recordByCustomer/form/CreateClaimTypeForm.vue';

    export default {
        components: {
            'csp-create-claim-type-form': CreateClaimTypeForm,
            'csp-create-damage-form': CreateDamageForm,
            'csp-create-damage-map-image': CreateDamageMapImage,
        },
        props: {
            recordForm: {
                type: RecordCreateForm,
                required: true,
            },
        },
        computed: {
            uploadFileCategory() {
                return FileCategoryEnum.PICTURE;
            },
            uploadSessionId() {
                return this.recordForm.getDataOfProperty('uploadSessionId');
            },
        },
    }
</script>
